<ng-container *ngIf="isEulaAccepted">

	<ng-container *ngIf="data$ | async as data else loading">
		@if(data.isValidCompany) {
		<div *ngIf="!data.isMainCompany && !data.currentAccessRequest" class="cards-container">
			<al-dashboard-tile *ngFor="let link of data.links" [item]="link" [azureItemdata]="data.functionAppData" [linkStatus$]="linkStatus$" [userCanRunLinks]="data.canRunLinks">
			</al-dashboard-tile>
			<al-marketplace-tile></al-marketplace-tile>
		</div>

		<div *ngIf="data.isMainCompany && !data.currentAccessRequest" class="cards-container">
			<al-subcompany-dashboard-tile *ngFor="let subCompany of data.subCompanies" [item]="subCompany" [accessRequestModal]="accessRequestModal">
			</al-subcompany-dashboard-tile>
		</div>

		<div class="center" *ngIf="data.currentAccessRequest">
			<div class="card">
				<div class="card-body message-dialog">
					<h4>Thank you for signing up with ApplicationLink.</h4>
					<p>A request for access to {{data.currentAccessRequest.companyName}} is currently pending approval by</p>
					<p>ApplicationLink support</p>

					<!-- retracting is only possible from main company, as access to main company is retained and a new request can be issued -->
					<button *ngIf="data.isMainCompany" type="button" class="btn btn-sm btn-warning" (click)="retractAccessRequest()">
                            Retract access request
                        </button>
				</div>
			</div>
		</div>
		} @else {
		<div class="center">
			<div class="card">
				<div class="card-body message-dialog">
					<!-- if this message appears, we messed up big somewhere
                    company selector component should validate company existence and access already
                    this is just here because displaying nothing at all is an even worse outcome -->
					<h4>Invalid company.</h4>

					<p>We were unable to confirm that the selected company is valid and that you have the right to access it.</p>
					<p>Apologies for the inconvenience.</p>
					<p>Please attempt the following:</p>
					<ul>
						<li>Select another company in the top right corner</li>
						<li>Refresh this window through your browser</li>
						<li>Log out and back in</li>
						<li>Contact support if the problem persists</li>
					</ul>
				</div>
			</div>
		</div>
		}
	</ng-container>

	<app-company-access-request-modal (accessRequested)="onAccessRequested()"></app-company-access-request-modal>

	<ng-template #loading>
		<div class="center">
			<div style="width:300px; height: 260px; border-radius: 18px" class="card">
				<div class="card-body">
					<div class="flex-container">
						<div class="flex-items">
							<img style="width:100%" [src]="getUrl('/application-logos/applicationink-logo.png')" />
						</div>
						<div style="height:30px;" class="flex-items">
							<hr>
						</div>
						<div class="flex-items">
							<div class="spinner-area">
								<div class="spinner"></div>
								<h4 style="margin-top: 0.20em;">retrieving data...</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</ng-container>
